<template>
	<div class="category-lists">
		<div class="fx-header">
			<p>店铺级分类</p>
		</div>
		<Search @handleSearch="handleSearch" :shopLists="shopLists"/>
		<div class="freight-btn-box">
			<el-button v-if="AuthorityList['01_0005_0009_00']" size="small" type="primary" class="freight-btn"  plain @click="addNew">新增</el-button>
		</div>
		<div class="table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				:height="tableHeight"
				@selection-change="selectionChangeHandle">
				<el-table-column
					label-class-name = "column-index"
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
					prop="name"
					label="模板名称"
					align="center"
					width="340">
				</el-table-column>
				<el-table-column
					prop="shopName"
					label="适用店铺"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="useing"
					label="使用中"
					align="center"
					width="180">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="240" align="center">
					<template v-slot="scopedSlot">
						<el-button size="mini" v-if="AuthorityList['01_0005_0010_00']" type='text' @click="editCurItem(scopedSlot.row)">编辑</el-button>
						<el-button size="mini" v-if="AuthorityList['01_0005_0011_00']" type='text' @click="manageCategory(scopedSlot.row)">管理分类</el-button>
						<el-button size="mini" v-if="AuthorityList['01_0005_0012_00']" type='text' @click="removeCurItem(scopedSlot.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
		<el-dialog
			top='100px'
			:title="templateType"
			class="detail-dialog-title"
			:visible.sync="visible"
			width='600px'
			:before-close="cancel"
			:close-on-click-modal="false">
			<div class="add-category">
				<div class="category-name-box">
					<div class="input-box">
						<span>模板名称：</span>
						<el-input
							v-model="templateName"
							placeholder="请输入模板名称"
							class="filter-input"
							size="small"
							:maxlength="20"
							@keyup.enter.native="search"
						></el-input>
					</div>
					<div class="checkbox-box">
						<div class="title">适用店铺：</div>
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选/反选</el-checkbox>
						<el-checkbox-group v-model="checkedShops" @change="checkedEvent">
							<el-checkbox v-for="item in shops" :label="item" :key="item">{{item}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="btn-box">
					<el-button size="small" class="btn" plain type="primary" @click="confirm">确定</el-button>
					<el-button size="small" class="btn" plain type="primary" @click="cancel">取消</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import Search from '@/components/categoryLists/Search.vue'
export default {
	name: 'categoryLists',
	components: {
		Search
	},
	data () {
		return {
			tableData: [],
			tableHeight: '100%',
			pagination: {
				page: 1,
				size: 20
			},
			shopLists: [],
			totalCount: 0,
			visible: false,
			templateName: '',
			templateId: 0,
			acceptShops: [],
			shops: [],
			checkedShops: [],
			checkAll: false,
			isIndeterminate: false,
			shopCategoryTemplateId: '',
			shopid: -1,
			templateType: '新增模板',
			AuthorityList: {
				'01_0005_0009_00': false,
				'01_0005_0010_00': false,
				'01_0005_0011_00': false,
				'01_0005_0012_00': false
			}
		}
	},
	created () {
		this.getShopCategoryTemplate()
		this.getAllShopBySyscodeId()
		this.getAuthority('01_0005_0000_00')
	},
	methods: {
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		getAllShopBySyscodeId () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customer/getAllShopBySyscodeId`
			}).then(res => {
				if (res.result) {
					this.shopLists = res.data
				}
			})
		},
		getShopCategoryTemplate () {
			let params = {
				shopId: this.shopid,
				templateName: this.templateName,
				page: this.pagination.page,
				size: this.pagination.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/shopCategory/getShopCategoryTemplate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.totalCount = res.data.recordCount
					this.tableData = res.data.recordList
				}
			})
		},
		checkedEvent (value) {
			let checkedCount = value.length
			this.checkAll = checkedCount === this.shops.length
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.shops.length
		},
		handleCheckAllChange (val) {
			this.checkedShops = val ? this.shops : []
			this.isIndeterminate = false
		},
		handleSearch (value) {
			this.pagination.page = 1
			this.pagination.size = 20
			this.templateName = value.name
			this.shopid = value.shopid
			this.getShopCategoryTemplate()
		},
		handleSizeChange (val) {
			this.pagination.size = val
		},
		handleCurrentChange (val) {
			this.pagination.page = val
		},
		selectionChangeHandle (value) {
			console.log(value)
		},
		addNew () {
			this.templateName = ''
			this.isIndeterminate = false
			this.templateId = 0
			this.templateType = '新增模板'
			this.checkedShops = []
			let params = {
				templateId: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/shopCategory/getUnbindTemplateShop`,
				data: params
			}).then(res => {
				if (res.result) {
					this.visible = true
					this.acceptShops = res.data
					this.shops = res.data.map(item => {
						return item.name
					})
					this.checkAll = false
				}
			})
		},
		editCurItem (row) {
			this.templateType = '编辑模板'
			let params = {
				templateId: row.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/shopCategory/getUnbindTemplateShop`,
				data: params
			}).then(res => {
				if (res.result) {
					this.templateName = row.name
					this.templateId = row.id
					this.visible = true
					this.acceptShops = res.data
					this.shops = res.data.map(item => {
						return item.name
					})
					let checkedShops = []
					res.data.forEach(item => {
						if (item.bindFlag) {
							checkedShops.push(item.name)
						}
					})
					this.checkedShops = checkedShops
					if (this.checkedShops.length === this.shops.length && this.checkedShops.length > 0) {
						this.checkAll = true
						return false
					}
					this.isIndeterminate = this.checkedShops.length > 0
				}
			})
		},
		removeCurItem (row) {
			this.$confirm('您是否确认删除当前分类模板?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.delShopcategoryTemplate(row)
			}).catch(() => {
				this.shopid = -1
				this.templateName = ''
			})
		},
		delShopcategoryTemplate (row) {
			let params = {
				templateId: row.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/shopCategory/delShopcategoryTemplate`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功!')
					this.getShopCategoryTemplate()
				}
			})
		},
		manageCategory (row) {
			this.$router.push({ path: '/main/categoryManagement', query: { id: row.id } })
		},
		confirm () {
			if (!this.templateName) {
				this.$message.error('请输入模板名称!')
				return
			}
			if (this.checkedShops.length < 1) {
				this.$message.error('请选择适用店铺!')
				return
			}
			let shopIds = []
			this.checkedShops.forEach(item => {
				this.acceptShops.forEach(i => {
					if (item === i.name) {
						shopIds.push(i.id)
					}
				})
			})
			let params = {
				name: this.templateName,
				templateId: this.templateId,
				shopIds: shopIds
			}
			let url = this.templateId ? `${this.$fxBaseApi.urlQIVShop}/shopCategory/updateShopcategoryTemplate` : `${this.$fxBaseApi.urlQIVShop}/shopCategory/addShopcategoryTemplate`
			this.$store.dispatch('requestPost', {
				url: url,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('操作成功，您可以管理分类了!')
					this.visible = false
					this.templateId = 0
					this.templateName = ''
					this.getShopCategoryTemplate()
				} else {
					this.$message.error(res.msg)
					this.visible = false
				}
			}).catch(err => {
				this.$message.error(err.msg)
				this.visible = false
			})
		},
		cancel () {
			this.templateId = 0
			this.visible = false
		}
	}
}
</script>

<style lang="stylus" scoped>
.category-lists {
	display: flex;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	height: 100%;
	min-height: 0;
	.freight-btn-box {
		display flex
		margin 20px 0
		.freight-btn {
			width: 125px
		}
	}
	.table-box {
		flex: 1
		padding-bottom: 10px
		overflow-y: auto;
		.grid-content {
			height 100%
		}
	}
	.detail-dialog-title {
		text-align left
	}
	.add-category {
		display:flex;
		margin-top: -15px;
		flex-direction: column;
		.category-name-box {
			display flex
			flex-direction: column;
			.input-box {
				display: flex
				width: 400px;
				line-height: 32px;
				margin-bottom: 10px
				.el-input {
					width: 300px;
				}
			}
			.checkbox-box {
				display flex;
				padding-bottom: 20px;
				.title {
					width: 70px
					flex-shrink: 0;
				}
				.el-checkbox-group {
					label {
						margin-bottom: 15px
					}
				}
			}
		}
		.btn-box {
			margin-top: 20px;
			display flex;
			justify-content: center;
			.btn {
				width: 120px
			}
		}
	}
}
</style>
